module.exports = require("react-dnd-html5-backend");